import React from 'react';

const CurentCount = ({row}) => {
  let displayData;
  if (row.bins.filter(b => b.currentCount !== null && typeof b.currentCount !== 'object' ).length > 0) {
    displayData = row.currentCount
  } else if (row.bins.some(b => b.currentCount)) {
    displayData = row.currentCount + '*'
  } else {
    displayData = '--'
  }
  return (
    <span>{displayData}</span>
  );
}

export default CurentCount;